import SidebarGroupsSection from "./SidebarGroupsSection";
import PopularTagsSidebar from "./PopularTagsSidebar";

export default function AppSidebar() {
  return (
    <aside className="app-sidebar w-full shrink-0" aria-label="Sidebar">
      <div className="app-sidebar-scroll">
        <div className="app-sidebar-panel">
          <section className="app-sidebar-section-card" aria-label="Groups">
            <SidebarGroupsSection />
          </section>
          <section className="app-sidebar-section-card" aria-label="Popular tags">
            <PopularTagsSidebar />
          </section>

          <div className="app-sidebar-support">
            <p className="app-sidebar-support__title">Support PeerPoetry</p>
            <p className="app-sidebar-support__text">
              Help keep the community free for poets everywhere.
            </p>
            <a
              href="https://buymeacoffee.com/imrandesk"
              target="_blank"
              rel="noopener noreferrer"
              className="app-sidebar-support__btn"
              title="Buy me a coffee"
            >
              <img
                src="/images/buy-me-a-coffee-logo.png"
                alt=""
                className="h-4 w-4 object-contain"
                aria-hidden="true"
              />
              <span>Buy us a coffee</span>
            </a>
          </div>
        </div>
      </div>
    </aside>
  );
}
